import { PageDS, Spacer, TabMenu, ToastContainerDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { HistoryTab } from "./historyTab";
import { ManagementTab } from "./managementTab";
import "../../../i18n/i18n";
import { useAppSelector } from "../../../redux/hooks";
import { selectManagersList } from "../users/usersSlice";
import { supportPhonesByCompanyGroupUuid } from "../../../constants/support";

export const Notifications = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();

  const managers = useAppSelector(selectManagersList);

  const otherSupportPhones = useMemo(
    () =>
      managers && managers.length > 0 && managers[0].companyGroup
        ? supportPhonesByCompanyGroupUuid[managers[0].companyGroup]
        : undefined,
    [managers],
  );

  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "history",
  );

  const tabs = [
    {
      name: "history",
      title: t("notifications.tab.history"),
    },
    {
      name: "management",
      title: t("notifications.tab.management"),
    },
  ];

  useEffect(() => {
    if (selectedTab) {
      navigate(`/home/notifications/${selectedTab}`);
    }
  }, [navigate, selectedTab]);

  return (
    <PageDS
      title={t("notifications.title")}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
          <Spacer y={0.5} />
        </>
      }
      supportButton={{
        showMail: !otherSupportPhones,
        otherPhones: otherSupportPhones,
      }}
    >
      <Spacer y={0.5} />
      <HistoryTab />
      <ManagementTab />
    </PageDS>
  );
};
